import React, { useEffect, useState } from "react";
import { Vendor } from "../../interfaces/vendor";
import { getVendors } from "../../services/vendorService";
import { useNavigate } from "react-router-dom";

const VendorOrders = () => {
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        setLoading(true);
        const vendorsResponse = await getVendors();
        const sortedVendors = vendorsResponse
          .filter((vendor) => vendor.isActive)
          .sort((a, b) => a.vendorName.localeCompare(b.vendorName));
        setVendors(sortedVendors);
      } catch {
        console.log("error fetching vendors");
      } finally {
        setLoading(false);
      }
    };
    fetchVendorData();
  }, []);

  return (
    <div className="content-container">
      <div className="header-container">
        <h1>Vendor Orders</h1>
        <div className="page-items-container"></div>
      </div>
      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          <div className="table-wrapper">
            <div className="table-container">
              <table
                className="table"
                style={{
                  cursor: "pointer",
                  fontSize: "large",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "600px" }}>Vendor Name</th>
                    <th style={{ width: "200px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {vendors?.length === 0 ? (
                    <tr>
                      <td colSpan={2}>No Vendors found.</td>
                    </tr>
                  ) : (
                    vendors?.map((vendor) => {
                      return (
                        <tr
                          key={vendor.vendorID}
                          onClick={() =>
                            navigate(`/admin/view-vendor/${vendor.vendorID}`)
                          }
                        >
                          <td style={{ textDecoration: "underline" }}>
                            {vendor.vendorName}
                          </td>

                          <td style={{ width: "100%", textAlign: "right" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <button
                                className="smbtn btn-grey"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/admin/vendor/process-orders/${vendor.vendorID}`,
                                  );
                                }}
                              >
                                Process Orders{" "}
                                <i className="btn-icon bi bi-arrow-right-circle"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VendorOrders;
